import { ko } from "date-fns/locale";
import { forwardRef, LegacyRef } from "react";
import { DateRange, RangeKeyDict } from "react-date-range";

type CalendarFilterProps = {
  open: boolean;
  onChange: (startDate: Date, endDate: Date) => void;
  selectedDate: [Date, Date];
};

//TODO: forwardRef가 어떤 역할을 하는지 알아봐야함
const CalendarFilter = forwardRef<HTMLDivElement, CalendarFilterProps>(
  ({ open, onChange, selectedDate, ...props }, ref) => {
    return (
      <div
        // onMouseDown={(e) => {
        //   e.preventDefault();
        // }}
        // tabIndex={-1}
        ref={ref}
        className="calendar-modal"
        style={{
          display: open ? "block" : "none",
          position: "absolute",
          boxShadow: "var(--alias-style-shadow-strong)",
          backgroundColor: "white",
          zIndex: 100,
          width: 356,
          left: 72,
          top: 38,
        }}
      >
        <DateRange
          locale={ko}
          ranges={[
            {
              startDate: selectedDate[0],
              endDate: selectedDate[1],
              key: "selection",
            },
          ]}
          onChange={(date: RangeKeyDict) => {
            const selection = date.selection;
            const start = selection?.startDate;
            const end = selection?.endDate;
            if (start && end) {
              onChange?.(start, end);
            }
          }}
          maxDate={new Date()}
        />
      </div>
    );
  }
);

export default CalendarFilter;
